import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestVeiculos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteVeiculo({ payload }) {
  try {
    const { idveiculo, params } = payload;

    yield call(api.delete, `veiculo/${idveiculo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.post, 'veiculo', veiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idveiculo } = payload;

    const { data } = yield call(api.get, `veiculo/${idveiculo}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { veiculo, params } = payload;

    yield call(api.put, 'veiculo', veiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@veiculo/VEICULOS_IN_REQUEST', requestVeiculos),
  takeLatest('@veiculo/DELETE_VEICULO', deleteVeiculo),
  takeLatest('@veiculo/SUCCESS_REMOVE', requestVeiculos),
  takeLatest('@veiculo/STORE_VEICULO', store),
  takeLatest('@veiculo/FIND_VEICULO', find),
  takeLatest('@veiculo/UPDATE_VEICULO', update),
  takeLatest('@veiculo/RECORD_FILTERING', applyedFilters),
]);
